let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("epd5A")).then(() => parcelRequire('j8EgG'));